import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePwaUpdate } from "@/hooks/usePwaUpdate";

/**
 * PWA update prompt component.
 * Shows when a new version is available and lets user choose when to update.
 * 
 * Uses 'prompt' strategy to prevent interrupting active work.
 */
export function UpdatePrompt() {
  const { needRefresh, handleUpdate, dismissUpdate } = usePwaUpdate();

  if (!needRefresh) return null;

  return (
    <div 
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 
                 bg-primary text-primary-foreground p-4 rounded-lg shadow-lg z-50
                 animate-in slide-in-from-bottom-4 duration-300"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <RefreshCw className="h-5 w-5 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-medium">Uusi versio saatavilla</p>
          <p className="text-sm opacity-90 mt-1">
            Päivitä saadaksesi uusimmat ominaisuudet ja korjaukset.
          </p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={dismissUpdate}
          className="flex-1 bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground"
        >
          Myöhemmin
        </Button>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleUpdate}
          className="flex-1 border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10"
        >
          Päivitä nyt
        </Button>
      </div>
    </div>
  );
}
